<template>
  <div class="contents contents--full">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>전체 기관의 품질평가 결과</h3>
        
        <select v-model="selectedYear" class="year-dropdown">
          <option v-for="year in availableYears" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <button @click="changeYear" class="select-download-btn">조회</button>
        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>전체 기관의 품질평가 결과</span>
        </div>
      </div>

      <div class="container">


        <br />

        <!-- <div class="summary-container">
          <h4>📊 기업별 통계 요약</h4>
          <table class="overall-summary-table">
            <thead>
              <tr>
                <th>평균 종류</th>
                <th v-for="(vo, index) in giasAvgList" :key="index">
                  {{ vo?.organizationName || '평가중' }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Domain 평균</td>
                <td v-for="(vo, index) in giasAvgList" :key="index">
                  {{ vo?.domainAvg || '평가중' }}
                </td>
              </tr>
              <tr>
                <td>Principle 평균</td>
                <td v-for="(vo, index) in giasAvgList" :key="index">
                  {{ vo?.prinAvg || '평가중' }}
                </td>
              </tr>
              <tr>
                <td>Standard 평균</td>
                <td v-for="(vo, index) in giasAvgList" :key="index">
                  {{ vo?.stanAvg || '평가중' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

        
        <!-- ✅ 평균 보기 버튼 -->
        <button @click="downloadExcel" class="excel-download-btn2">엑셀 다운로드</button>
        <div class="button-group">
          <button @click="toggleGrid('domain')" :class="{ active: showDomainGrid }">Doamin 평균 보기</button>
          <button @click="toggleGrid('principle')" :class="{ active: showPrincipleGrid }">Principle 평균 보기</button>
          <button @click="toggleGrid('standard')" :class="{ active: showStandardGrid }">Standard 평균 보기</button>
        </div>
        <div class="summary-container" v-if="showDomainGrid">
          <h4>📊 기관별 도메인 평균</h4>

          <table class="overall-summary-table">
            <thead>
              <tr>
                <th>Domain</th> <!-- 도메인 이름 -->
                <th>전체 평균</th> <!-- 추가된 전체 평균 -->
                <th v-for="(company, index) in uniqueOrganizations" :key="index">
                  {{ company.organizationName || "평가중" }}
                </th>
              </tr>
            </thead>
            
            <tbody>
              <tr v-for="(domain, index) in uniqueDomains" :key="index">
                <td class="domain-column" v-html="formatName(domain)"></td> <!-- 도메인 이름 변환 적용 -->
                <td class="total-avg-score">{{ getTotalDomainAvg(domain) || "평가중" }}</td> <!-- 전체 평균 -->
                <td 
                  v-for="(company, companyIndex) in uniqueOrganizations" 
                  :key="`score-${companyIndex}`"
                  :class="getScoreClass(getDomainAvg(company.organizationCode, domain), getTotalDomainAvg(domain))"
                >
                  {{ getDomainAvg(company.organizationCode, domain) || "평가중" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div class="summary-container" v-if="showPrincipleGrid" >
          <h4>📊 기관별 프린서펄 평균</h4>

          <table class="overall-summary-table">
            <thead>
              <tr>
                <th>Principle</th> <!-- 프린서펄 이름 -->
                <th>전체 평균</th> <!-- 추가된 전체 평균 -->
                <th v-for="(company, index) in uniqueOrganizations" :key="index">
                  {{ company.organizationName || "평가중" }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(principle, index) in uniquePrinciples" :key="index">
                <td class="domain-column" v-html="formatName(principle)"></td> <!-- 프린서펄 이름 변환 적용 -->
                <td class="total-avg-score">{{ getTotalPrincipleAvg(principle) || "평가중" }}</td> <!-- 전체 평균 -->
                <td 
                  v-for="(company, companyIndex) in uniqueOrganizations" 
                  :key="`score-${companyIndex}`"
                  :class="getScoreClass(getPrincipleAvg(company.organizationCode, principle), getTotalPrincipleAvg(principle))"
                >
                  {{ getPrincipleAvg(company.organizationCode, principle) || "평가중" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <!-- ✅ 스탠다드(표준) 평균 그리드 -->
        <div class="summary-container" v-if="showStandardGrid">
          <h4>📊 기업별 스탠다드 평균 요약</h4>
          <table class="overall-summary-table">
            <thead>
              <tr>
                <th>Standard</th> <!-- 스탠다드 이름 -->
                <th>전체 평균</th> <!-- 추가된 전체 평균 -->
                <th v-for="(company, index) in uniqueOrganizations" :key="index">
                  {{ company.organizationName || "평가중" }}
                </th>
              </tr>
            </thead>
            
            <tbody>
              <tr v-for="(standard, index) in uniqueStandards" :key="index">
                <td class="domain-column" v-html="formatName(standard)"></td> <!-- 스탠다드 이름 변환 적용 -->
                <td class="total-avg-score">{{ getTotalStandardAvg(standard) || "평가중" }}</td> <!-- 전체 평균 -->
                <td v-for="(company, companyIndex) in uniqueOrganizations" :key="`score-${companyIndex}`"
                    :class="getScoreClass(getStandardAvg(company.organizationCode, standard), getTotalStandardAvg(standard))">
                  {{ getStandardAvg(company.organizationCode, standard) || "평가중" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      
      </div>
    </div>
  </div>

</template>


<script setup>
import { reactive, ref, computed, onMounted,onUnmounted  } from "vue";
import { useStore } from "vuex";
import { useRouter,useRoute } from 'vue-router'
import * as XLSX from "xlsx";
const store = useStore();
const route = useRoute()
// 필터링 상태
const selectedDomainCode = ref(null);

const selectedYear = ref('2025');

// 연도 목록 (현재 연도부터 과거 5년까지)
const availableYears = ref(
  Array.from({ length: 3 }, (_, i) => new Date().getFullYear() - i)
);

// 저장한 평가 데이터 조회
const changeYear = async () => {
  getEvlData()
};

// 도메인 데이터 가져오기
const domainList = computed(() => store.state.grid.domainData);// 도메인 데이터 가져오기
const orgEvlList = computed(() => store.state.grid.evlOrgData2);// 평가데이터 가져오기기

const giasAvgList = computed(() => store.state.grid.evlAvgData); // 기업별 통계 요약
const checkUserId = computed(() => store.state.temp.userInfo);

const showDomainGrid = ref(true);   // 도메인 평균 보기 여부
const showPrincipleGrid = ref(false); // 프린서펄 평균 보기 여부
const showStandardGrid = ref(false);  // 스탠다드 평균 보기 여부

const getScoreClass = (companyScore, totalAvg) => {
  if (!companyScore || companyScore === "평가중") return "";
  return parseFloat(companyScore) < parseFloat(totalAvg) ? "low-score" : "";
};

// ✅ 버튼 클릭 시 특정 테이블만 보이도록 설정
const toggleGrid = (type) => {
  showDomainGrid.value = type === "domain";
  showPrincipleGrid.value = type === "principle";
  showStandardGrid.value = type === "standard";
};

// 📌 모든 기관 (중복 제거)
const uniqueOrganizations = computed(() => {
  const orgSet = new Map();
  orgEvlList.value.forEach(vo => {
    if (vo.organizationCode) {
      orgSet.set(vo.organizationCode, { 
        organizationCode: vo.organizationCode, 
        organizationName: vo.organizationName 
      });
    }
  });
  return Array.from(orgSet.values());
});

// 📌 모든 도메인 (중복 제거)
const uniqueDomains = computed(() => {
  const domainSet = new Set();
  orgEvlList.value.forEach(vo => {
    if (vo.domainName) {
      domainSet.add(vo.domainName);
    }
  });
  return Array.from(domainSet);
});

// 📌 특정 기관의 특정 도메인 평균 점수 반환 함수
const getDomainAvg = (organizationCode, domainName) => {
  const domainData = orgEvlList.value.find(vo => 
    vo.organizationCode === organizationCode && vo.domainName === domainName
  );
  return domainData ? domainData.avgDomainScore.toFixed(2) : null;
};

// 📌 전체 평균 계산 함수 (해당 도메인의 모든 기업 평균)
const getTotalDomainAvg = (domainName) => {
  const filteredData = orgEvlList.value.filter(vo => vo.domainName === domainName);
  if (filteredData.length === 0) return null; // 데이터 없으면 null 반환

  const totalScore = filteredData.reduce((sum, vo) => sum + (vo.avgDomainScore || 0), 0);
  return (totalScore / filteredData.length).toFixed(2); // 평균값 반환
};

// 고유한 프린서펄 목록 가져오기
const uniquePrinciples = computed(() => {
  const principles = new Set();
  orgEvlList.value.forEach((item) => {
    if (item.principleName) {
      principles.add(item.principleName);
    }
  });
  return Array.from(principles);
});

// 전체 프린서펄 평균 점수 계산
const getTotalPrincipleAvg = (principleName) => {
  const scores = orgEvlList.value
    .filter(item => item.principleName === principleName)
    .map(item => item.avgPrincipleScore);

  if (scores.length === 0) return "평가중";

  const totalSum = scores.reduce((sum, score) => sum + (score || 0), 0);
  return (totalSum / scores.length).toFixed(2);
};

// 특정 기업의 프린서펄 평균 점수 조회
const getPrincipleAvg = (organizationCode, principleName) => {
  const entry = orgEvlList.value.find(item => 
    item.organizationCode === organizationCode && item.principleName === principleName
  );

  return entry?.avgPrincipleScore?.toFixed(2) || "평가중";
};

// ✅ 유니크한 스탠다드(표준) 목록 가져오기
const uniqueStandards = computed(() => {
  const standardSet = new Set();
  orgEvlList.value.forEach((item) => {
    if (item.standardName) standardSet.add(item.standardName);
  });
  return Array.from(standardSet);
});

// ✅ 특정 스탠다드의 전체 평균 가져오기
const getTotalStandardAvg = (standard) => {
  const filtered = orgEvlList.value.filter((item) => item.standardName === standard);
  if (filtered.length === 0) return "평가중";

  const totalSum = filtered.reduce((sum, item) => sum + (item.avgStandardScore || 0), 0);
  return (totalSum / filtered.length).toFixed(2);
};

// ✅ 특정 기업의 특정 스탠다드 평균 가져오기
const getStandardAvg = (organizationCode, standard) => {
  const entry = orgEvlList.value.find(
    (item) => item.organizationCode === organizationCode && item.standardName === standard
  );
  return entry ? entry.avgStandardScore?.toFixed(2) : "평가중";
};



// -> 이 코드는 api를 호출한 데이터를 기반으로 엑셀화 시킴
const downloadExcel = () => {
  const workbook = XLSX.utils.book_new();

  /** 📊 1. 도메인 평균 시트 생성 */
  const domainWorksheetData = [];
  const domainHeaders = ["Domain", "전체 평균", ...(uniqueOrganizations.value || []).map(org => org.organizationName || "평가중")];
  domainWorksheetData.push(domainHeaders);

  (uniqueDomains.value || []).forEach(domain => {
    const row = [
      domain,
      getTotalDomainAvg(domain) || "평가중",
      ...(uniqueOrganizations.value || []).map(org => getDomainAvg(org.organizationCode, domain) || "평가중")
    ];
    domainWorksheetData.push(row);
  });

  const domainWorksheet = XLSX.utils.aoa_to_sheet(domainWorksheetData);
  XLSX.utils.book_append_sheet(workbook, domainWorksheet, "Domain 평균");

  /** 📊 2. 프린서펄 평균 시트 생성 */
  const principleWorksheetData = [];
  const principleHeaders = ["Principle", "전체 평균", ...(uniqueOrganizations.value || []).map(org => org.organizationName || "평가중")];
  principleWorksheetData.push(principleHeaders);

  (uniquePrinciples.value || []).forEach(principle => {
    const row = [
      principle,
      getTotalPrincipleAvg(principle) || "평가중",
      ...(uniqueOrganizations.value || []).map(org => getPrincipleAvg(org.organizationCode, principle) || "평가중")
    ];
    principleWorksheetData.push(row);
  });

  const principleWorksheet = XLSX.utils.aoa_to_sheet(principleWorksheetData);
  XLSX.utils.book_append_sheet(workbook, principleWorksheet, "Principle 평균");

  /** 📊 3. 스탠다드 평균 시트 생성 */
  const standardWorksheetData = [];
  const standardHeaders = ["Standard", "전체 평균", ...(uniqueOrganizations.value || []).map(org => org.organizationName || "평가중")];
  standardWorksheetData.push(standardHeaders);

  (uniqueStandards.value || []).forEach(standard => {
    const row = [
      standard,
      getTotalStandardAvg(standard) || "평가중",
      ...(uniqueOrganizations.value || []).map(org => getStandardAvg(org.organizationCode, standard) || "평가중")
    ];
    standardWorksheetData.push(row);
  });

  const standardWorksheet = XLSX.utils.aoa_to_sheet(standardWorksheetData);
  XLSX.utils.book_append_sheet(workbook, standardWorksheet, "Standard 평균");

  /** 📊 4. 엑셀 파일 생성 및 다운로드 */
  XLSX.writeFile(workbook, `통계_전체_테이블.xlsx`);
};





const getPrincipleRowspan = (principle) => {
  return principle.standards.reduce((count, standard) => count + standard.evaluations.length, 0);
};

// 텍스트에 <br> 삽입하는 함수
const formatName = (name) => {
  if (!name) return "";
  return name.replace(/\(/g, "<br>("); // '(' 이전에 <br> 추가
};

// 모든 평가 항목 조회
const getGridData = async () => {
  let param = {
    memberCode: checkUserId.value.memberCode,
  };
  await store.dispatch("grid/fetchAllDomain", param);
};

// 저장한 평가 데이터 조회
const getEvlData = async () => {

  let param = {
    orgGiasYear : selectedYear.value
  };

  await store.dispatch("grid/fetchAllOrgStats",param);
};

// 기업별 통계 요약
const getGiasAvg = async () => {
  await store.dispatch("grid/fetchAvgData");
};

onMounted(async () => {
  //console.log("기관이름" + orgName.value )
  //await getGridData(); //메인 그리드 평가항목리스트
  await getEvlData(); // 기업별 모든 평균값
  //await getGiasAvg();  // 모든 기업의 전체 통계 요약
});

// 컴포넌트 언마운트 시 호출
onUnmounted(() => {
  // Store의 clearEvlOrgData를 호출
  store.commit("grid/clearEvlOrgData2");
})
</script>

<style >
.stats-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.stats-table th{
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.6; /* 줄 간격 조정 */
  font-size: 12px;
}
.stats-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center; /* 셀 텍스트 수평 중앙 정렬 */
  vertical-align: middle; /* 셀 텍스트 수직 중앙 정렬 */
  line-height: 1.4;
  font-size: 10px;
}

.stats-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.stats-table td {
  vertical-align: top;
}

/* 요약 테이블 스타일 */

.summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 20px 0;
  font-size: 12px;
}

.summary-table th, .summary-table td {
  border: 1px solid #000;
  padding: 10px;
}

.summary-table .highlight {
  background-color: #00a651;
  color: #fff;
  font-weight: bold;
}


/* 점수에 따른 배경색 */
.score-excellent {
  background-color: #00a651; /* 매우 충족 - 초록 */
  color: white;
}

.score-satisfactory {
  background-color: #92d050; /* 충족 - 연두 */
  color: black;
}

.score-needs-improvement {
  background-color: #ffff00; /* 개선여지 - 노랑 */
  color: black;
}

.score-weak {
  background-color: #ffc000; /* 취약 - 주황 */
  color: black;
}

.score-very-weak {
  background-color: #ff0000; /* 매우 취약 - 빨강 */
  color: white;
}

.score-pending {
  background-color: #eaeaea; /* 평가중 - 회색 */
  color: black;
}

/**  통계 데이터의 헤더가 따라옴*/
.stats-table thead th {
  position: sticky; /* 스크롤에 따라 고정 */
  top: 0; /* 화면 상단부터의 거리 */
  z-index: 2; /* 겹치는 요소 위에 표시되도록 설정 */
  background-color: #f4f4f4; /* 배경색 (헤더가 읽기 쉽게) */
  text-align: center; /* 텍스트 가운데 정렬 */
  border-bottom: 2px solid #ddd; /* 헤더 하단 선 */
  padding: 8px;
  font-weight: bold;
  line-height: 1.6;
}

.excel-download-container {
  position: fixed; /* 고정 위치 설정 */
  top: 20px; /* 화면 상단에서 20px */
  right: 20px; /* 화면 오른쪽에서 20px */
  z-index: 1000; /* 다른 요소 위에 표시되도록 설정 */
}

.excel-download-btn2 {
  background-color: #007bff; /* 파란색 버튼 */
  color: white; /* 텍스트 색상 */
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
  margin-left: 5px;
  margin-top : -2px;
  /* ✅ 추가 */
  float: right;
}

.excel-download-btn2:hover {
  background-color: #0056b3; /* 호버 시 색상 */
}

.select-download-btn {
  background-color: #92d050; /* 파란색 버튼 */
  color: white; /* 텍스트 색상 */
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.2s;
  margin-left: 5px;
  margin-top : -2px;
}

.select-download-btn:hover {
  background-color: #00a651; /* 호버 시 색상 */
}

.summary-container {
  max-width: 100%;
  overflow-x: auto; /* 가로 스크롤 가능하도록 설정 */
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9fafc;
  padding: 15px;
}

.summary-container h4 {
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.overall-summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.overall-summary-table th,
.overall-summary-table td {
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
}

.overall-summary-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.overall-summary-table td {
  font-size: 12px;
  font-weight: bold;
}

/* 도메인 이름 컬럼의 크기 조정 */
.domain-column {
  max-width: 150px; /* 원하는 최대 너비 설정 */
  word-wrap: break-word; /* 긴 단어가 있을 경우 줄바꿈 */
  white-space: normal; /* 줄바꿈 허용 */
}

.low-score {
  background-color: #ffcccc !important; /* 연한 빨간색 배경 */
  color: #d8000c; /* 진한 빨간색 글자 */
  font-weight: bold;
}

.button-group {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  justify-content: center; /* 가운데 정렬 */
}

.button-group button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.button-group button:hover {
  background-color: #0056b3;
}

.button-group button.active {
  background-color: #28a745;
}

.year-dropdown {
  margin-left: 10px; /* 간격 추가 */
  padding: 2px 2px; /* 내부 패딩 */
  border: 1px solid #ccc; /* 테두리 스타일 */
  border-radius: 4px; /* 둥근 모서리 */
  font-size: 14px; /* 글꼴 크기 */
  cursor: pointer; /* 포인터 커서 */
  height: 25px;
  width: 50px;
  text-align: center;
}

.year-dropdown:focus {
  border-color: #0078d7; /* 포커스 시 테두리 색상 변경 */
  outline: none;
}

</style>



